module.exports = __webpack_public_path__ + "static/media/maxprod.b4102ee2.gif";